import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PifListItem } from "../../pages/supervision/PostInterviewForm/types";
import PostIFStatusChip from "./PostIFStatusChip";

interface PostIFDetailDialogProps {
  record: PifListItem | null;
  openLabel: string;
  onClose: () => void;
  onOpen: (record: PifListItem) => void;
}

const PostIFDetailDialog: React.FC<PostIFDetailDialogProps> = ({
  record,
  openLabel,
  onClose,
  onOpen,
}) => (
  <Dialog
    open={Boolean(record)}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
    aria-labelledby="postif-detail-title"
    data-testid="postif-lightbox"
  >
    <DialogTitle id="postif-detail-title">{record?.title ?? "Post Interview Form"}</DialogTitle>

    <IconButton aria-label="close" onClick={onClose} className="dialog-close-button">
      <CloseIcon />
    </IconButton>

    <DialogContent dividers>
      {record && (
        <div className="postif-detail">
          <dl className="postif-detail__facts">
            <dt>Applicant</dt>
            <dd>{record.applicant}</dd>

            <dt>Flow</dt>
            <dd>{record.flow}</dd>

            <dt>Department</dt>
            <dd>{record.department}</dd>

            <dt>Position</dt>
            {/* Bug 82246: the employment type can now be absent - a bare "Position · " would
                otherwise trail a separator with nothing after it. */}
            <dd>{[record.position, record.employmentType].filter(Boolean).join(" · ")}</dd>

            <dt>Created by</dt>
            <dd>{record.createdBy === "You" ? "You (current supervisor)" : record.createdBy}</dd>

            <dt>Status</dt>
            <dd>
              <PostIFStatusChip status={record.status} />
            </dd>
          </dl>

          <h6 className="postif-detail__section-title">Approval chain</h6>
          <ol className="postif-detail__chain">
            {record.approvals.map((step) => (
              <li key={step.label} className={`postif-detail__step postif-detail__step--${step.state}`}>
                <span className="postif-detail__step-label">{step.label}</span>
                <span className="postif-detail__step-detail">{step.detail}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </DialogContent>

    <DialogActions>
      <Button variant="contained" color="light" size="small" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="small"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        onClick={() => {
          if (record) onOpen(record);
        }}
      >
        {openLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default PostIFDetailDialog;
